import { render, staticRenderFns } from "./shareList.vue?vue&type=template&id=a9a7277a&scoped=true&"
import script from "./shareList.vue?vue&type=script&lang=ts&"
export * from "./shareList.vue?vue&type=script&lang=ts&"
import style0 from "./shareList.vue?vue&type=style&index=0&id=a9a7277a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a7277a",
  null
  
)

export default component.exports